import styled from 'styled-components';
import { layout } from 'src/components/base';

export const BreadCrumbWrapper = styled.div`
  display: flex;
  margin: ${layout.measurements.spacing050} 0 ${layout.measurements.spacing050}
    ${layout.measurements.spacing050};
`;
